import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";
import { EditOfferResponse } from "../../../../orchestrator-api-client";

export const editOfferReducer = (
  state: LoanState,
  action: PayloadAction<EditOfferResponse>,
) => {
  state.simulationOfferFailed = action.payload.simulationFailed;
  state.offersAttempts = action.payload.offersAttempts;
  state.offers = action.payload.offers;
};

export const isLastEditOfferReducer = (
  state: LoanState,
  action: PayloadAction<boolean>,
) => {
  state.simulationOfferFailed = action.payload;
};
